<template>
    <div class="report-center">
        <div class="report-center-toolbar">
            <div class="report-search-bar">
                <span class="report-search-bar-icon" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
                        <line
                            x1="21"
                            y1="21"
                            x2="16.65"
                            y2="16.65"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                    </svg>
                </span>
                <input
                    v-model="search"
                    class="report-search-bar-input"
                    type="text"
                    placeholder="Search reports by name..."
                    aria-label="Search reports by name"
                />
                <button
                    v-if="search"
                    type="button"
                    class="report-search-bar-clear"
                    aria-label="Clear search"
                    @click="search = ''"
                >
                    &times;
                </button>
            </div>
        </div>
        <div class="report-center-grid">
            <section
                v-for="section in filteredSections"
                :key="section.title"
                class="report-section"
                :aria-label="section.title"
            >
                <header class="report-section-header">
                    <h2 class="report-section-title">{{ section.title }}</h2>
                </header>

                <div class="report-section-body">
                    <p v-if="section.reports.length === 0" class="report-section-empty">
                        No reports match your search.
                    </p>
                    <div v-for="report in section.reports" :key="report.name" class="report-row">
                        <a class="report-row-title" href="javascript:void(0)" @click="openReport(report.path)">
                            {{ report.name }}
                        </a>
                        <i
                            class="fas fa-info-circle text-primary font-size-sm ms-2"
                            v-tooltip="{ title: getReportTooltip(report), placement: 'top' }"
                        >
                        </i>
                    </div>
                </div>
            </section>
        </div>
        <p v-if="filteredSections.every((s) => s.reports.length === 0) && search" class="report-center-no-results">
            No reports found for "{{ search }}".
        </p>
    </div>
</template>

<script lang="ts" src="./ReportCenter.ts"></script>
<style lang="scss" scoped src="./ReportCenter.scss"></style>
